export const getTodayDateString = () => new Date().toISOString().slice(0, 10)

export const isToday = dateString => dateString === getTodayDateString()

export const addDays = (dateString, days) => {
  var result = new Date(dateString)
  result.setDate(result.getDate() + days)
  return result.toISOString().slice(0, 10)
}
